var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.84766,
    y: 4.02368,
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#B1D7D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.84766,
    y: 4.02368,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "#E0EFEF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5221 22.8333H29.1888C28.4374 22.8333 27.7167 23.1318 27.1853 23.6632C26.654 24.1946 26.3555 24.9152 26.3555 25.6667V48.3333C26.3555 49.0848 26.654 49.8055 27.1853 50.3368C27.7167 50.8682 28.4374 51.1667 29.1888 51.1667H46.1888C46.9402 51.1667 47.6609 50.8682 48.1923 50.3368C48.7236 49.8055 49.0221 49.0848 49.0221 48.3333V31.3333M40.5221 22.8333L49.0221 31.3333M40.5221 22.8333V31.3333H49.0221M43.3555 38.4167H32.0221M43.3555 44.0833H32.0221M34.8555 32.75H32.0221",
    stroke: "#006766",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.32131d65ff2b44c24c5cacae5d3a19c2.svg";
export { ForwardRef as ReactComponent };